import React from 'react';
interface BonusCardProps {
  image: string;
  title: string;
  value: string;
  description: string;
}
export function BonusCard({
  image,
  title,
  value,
  description
}: BonusCardProps) {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('purchase-section');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div onClick={scrollToPurchase} className="bg-white rounded-xl overflow-hidden shadow-lg border border-slate-100 cursor-pointer hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group" data-id="element-1">
      <div className="relative aspect-square overflow-hidden bg-slate-100" data-id="element-2">
        <img src={image} alt={title} className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105" data-id="element-3" />
        <div className="absolute top-0 right-0 bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg shadow-sm" data-id="element-4">
          GRATIS HOY
        </div>
      </div>
      <div className="p-5" data-id="element-5">
        <div className="flex justify-between items-start mb-2" data-id="element-6">
          <h3 className="font-bold text-lg text-slate-900 leading-tight" data-id="element-7">
            {title}
          </h3>
        </div>
        <p className="text-sm text-slate-600 mb-3" data-id="element-8">{description}</p>
        <div className="inline-block bg-teal-50 text-teal-700 text-xs font-bold px-2 py-1 rounded border border-teal-100" data-id="element-9">
          Valor real: {value}
        </div>
      </div>
    </div>;
}